/**
 * Actual cash applied to the bill for ORDER_API_07 `cashamount`.
 * Uses user-entered cash, capped by net due after non-cash payments.
 */
export function resolveCashAmountForOrderPost({
  cashTendered,
  formDataCashAmount,
  totNett,
  advanceAmount,
  creditNoteAmount,
  giftAmount,
  loyaltyAmount,
  cardAmount,
  chequeAmount,
  slipAmount,
}) {
  const rawCash =
    parseFloat(cashTendered) ||
    parseFloat(formDataCashAmount) ||
    0;

  const nonCash =
    (parseFloat(creditNoteAmount) || 0) +
    (parseFloat(giftAmount) || 0) +
    (parseFloat(loyaltyAmount) || 0) +
    (parseFloat(cardAmount) || 0) +
    (parseFloat(chequeAmount) || 0) +
    (parseFloat(slipAmount) || 0);

  const nett = parseFloat(totNett) || 0;
  const advance = parseFloat(advanceAmount) || 0;
  const maxCashApplied = Math.max(0, nett - advance - nonCash);

  const applied = rawCash > 0 ? Math.min(rawCash, maxCashApplied) : 0;
  return Number(applied.toFixed(2));
}
